export function dateToString(dateString, locale, day = false, weekday = false, month = true, year = true) {
    const date = new Date(dateString);
    const opts = {
        ...(weekday && { weekday: 'long' }),
        ...(day && { day: 'numeric' }),
        ...(year && { year: 'numeric' }),
        ...(month && { month: 'long' }),
    };

    return date.toLocaleString(locale, opts);
}
